import axios from 'axios';

const UserJourneyServices = {
    get: (rooturl) => {
        return axios.get("api/userjourney/my/" + rooturl, {}, { withCredentials: true });
    },
    post: (path, url) => {
        const request = { "rootURL": path, "branchURL": url };
        return axios.post("api/userjourney", request, { withCredentials: true });
    }
};

const ModuleCompletionServices = {
    getLast: () => {
        return axios.get("api/modulecompletion/my/last/all", {}, { withCredentials: true });
    },
    getCert: (moduleid, filename) => {
        return axios.get("api/modulecompletion/my/cert/module/" + moduleid + "/" + filename, { responseType: 'blob' })

    }
  
};
const ModuleRefreshSettingServices = {
    getCycles: () => {
        return axios.get("api/modulerefreshsetting/cycles", {}, { withCredentials: true });
    },

};
const RefreshRequestServices = {
    getLast: () => {
        return axios.get("api/refreshrequest/my/last/all" , {}, { withCredentials: true });
    },
    create: (request) => {
        return axios.post("api/refreshrequest", request, { withCredentials: true });
    }

};
const QuizAttemptServices = {
    post: (request) => {
        return axios.post("api/quizattempt", request, { withCredentials: true });
    }
};
const InstitutionServices = {
    getAllowSelfReset: () => {
        return axios.get("api/institution/selfreset", {}, { withCredentials: true });
    },

};
const FeedbackServices = {
    post: (request) => {
        return axios.post("api/feedback", request, { withCredentials: true });
    }
};

export { QuizAttemptServices };
export { UserJourneyServices };
export { ModuleCompletionServices };
export { ModuleRefreshSettingServices };
export { RefreshRequestServices };
export { InstitutionServices };
export { FeedbackServices };